<div class="cb-layout-wrapper" [class.cb-fill]="fillViewport()">
    @if(hasTopNavbar()){
    <div class="cb-layout-top-navbar">
        <ng-content select="cb-top-navbar"></ng-content>
    </div>
    }
    <div class="cb-layout-container">
        @if(hasLeftSidebar()){
        <div class="cb-layout-sidebar-area cb-layout-left-sidebar">
            <ng-content select="cb-sidebar[position='left']"></ng-content>
        </div>
        }

        <div class="cb-layout">
            @if(hasHeader()){
            <div class="cb-layout-header">
                <ng-content select="cb-layout-toolbar[area='header']"></ng-content>
            </div>
            }
            @if(hasBody()){
            <div class="cb-layout-body" [class.cb-layout-row]="hasCols()" [class.cb-layout-col]="hasRows()">
                @if(hasRows()){
                <ng-content select="cb-layout-row"></ng-content>
                } @else if(hasCols()){
                <ng-content select="cb-layout-col"></ng-content>
                }
            </div>
            }

            @if(hasFooter()){
            <div class="cb-layout-footer">
                <ng-content select="cb-layout-toolbar[area='footer']"></ng-content>
            </div>
            }

        </div>

        @if(hasRightSidebar()){
        <div class="cb-layout-sidebar-area cb-layout-right-sidebar">
            <ng-content select="cb-sidebar[position='right']"></ng-content>
        </div>
        }
    </div>
</div>